import LoadStatus from '../../../../../../common/enums/loads/load-status.enum';
import ILoadCardInfo from '../../../../../../common/interfaces/loads/ILoadCardInfo';

// eslint-disable-next-line import/prefer-default-export
export const loadIsConfirmed = (
    loadData: ILoadCardInfo,
    isTmsConfirmed: boolean,
): boolean => {
    return loadData.tagStatus === LoadStatus.Confirmed || isTmsConfirmed;
};
